module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fikJB"))).then(() => parcelRequire('d0iPb'));